import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { isBanner, LazyLoadOptions, LISTER_TILES_ID, } from '@as-react/common-types';
import { Grid, useBreakpoints, generateBreakpointsMap } from '@yonderland/andes-react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PLACEHOLDER_TILES } from '../../constants/GeneralConstants';
import { makeGetUrlQueryInformationState } from '../../redux/url/selectors/UrlSelectors';
import { ProductTileVertical } from '../product-tile/vertical/ProductTileVertical';
import { BannerTile } from './banner-tile/BannerTile';
import { GridTilePlaceholder } from './grid-tile-placeholder/GridTilePlaceholder';
import { RowBanner } from './row-banner/RowBanner';
const GRID_COLUMNS = generateBreakpointsMap({
    xs: 2,
    md: 3,
    xl: 4,
});
const shouldShowContentBlock = (itemsLength, activeBreakpoint, visibleInRow, shownContentBlocks) => {
    const itemsPerRow = GRID_COLUMNS[activeBreakpoint];
    const previousRowWithItems = visibleInRow - (1 + shownContentBlocks);
    const minimumItemsToFillPreviousRow = itemsPerRow * previousRowWithItems - itemsPerRow;
    return itemsLength > minimumItemsToFillPreviousRow;
};
export const GridTileContainer = ({ isLoading, items, onTileClick, updateCompareList, onWishListToggle, contentBlocks, singleActiveSizeFilterKeyName, compareItems, }) => {
    const { feature_toggles: { lister_colour_swatches_visible_mobile, lister_colour_swatches_visible_desktop, lowest_price_all, }, isShopLanding, canonicalUrl, } = useAemConfig();
    const queryInformation = useSelector(makeGetUrlQueryInformationState());
    const { active: activeBreakpoint } = useBreakpoints();
    const determineLazyLoadState = (index) => index < PLACEHOLDER_TILES.length
        ? LazyLoadOptions.NO_LAZY_LOAD
        : index < PLACEHOLDER_TILES.length * 1.5
            ? LazyLoadOptions.LAZY_PRE_LOAD
            : LazyLoadOptions.LAZY_LOAD;
    const shownContentBlocks = useMemo(() => contentBlocks
        .sort((a, b) => a.visibleInRow - b.visibleInRow)
        .reduce((acc, contentBlock) => {
        if ((!contentBlock.visibleOnPage || contentBlock.visibleOnPage === (queryInformation.page || 0) + 1) &&
            shouldShowContentBlock(items.length, activeBreakpoint, contentBlock.visibleInRow, acc.length)) {
            return [...acc, contentBlock];
        }
        return acc;
    }, []), [contentBlocks, queryInformation.page, items.length, activeBreakpoint]);
    const generateRowBanner = (contentBlock, index) => (_jsx(Grid.Cell, { rowOffset: contentBlock.visibleInRow, span: "full", children: _jsx(RowBanner, { content: contentBlock.content }) }, `row-banner-item-${index}`));
    return (_jsxs(Grid, { id: LISTER_TILES_ID, testId: LISTER_TILES_ID, columns: GRID_COLUMNS, align: "end", gap: {
            xs: 4,
            sm: 6,
            lg: 8,
        }, children: [isLoading
                ? PLACEHOLDER_TILES.map((_, index) => _jsx(GridTilePlaceholder, {}, `grid-item-${index}`))
                : items.map((item, index) => {
                    var _a;
                    const shouldLazyLoadImage = determineLazyLoadState(index);
                    if (isBanner(item)) {
                        const { image, url, alt } = item.images[0];
                        return (_jsx(BannerTile, { lazy: shouldLazyLoadImage === LazyLoadOptions.LAZY_LOAD, url: url, image: image, zitchaInfo: item.adId && item.isSponsored
                                ? {
                                    adId: item.adId,
                                    isSponsored: item.isSponsored,
                                    position: (_a = item === null || item === void 0 ? void 0 : item.listerPosition) !== null && _a !== void 0 ? _a : 0,
                                    impressionURL: canonicalUrl !== null && canonicalUrl !== void 0 ? canonicalUrl : '',
                                }
                                : undefined, alt: alt }, `grid-item-${index}`));
                    }
                    return (_jsx(ProductTileVertical, { position: index + 1, product: item, onTileClick: onTileClick, onWishListToggle: onWishListToggle, updateCompareList: updateCompareList, compareItems: compareItems, shouldLazyLoadImage: shouldLazyLoadImage, alwaysShowSwatches: isShopLanding, showSwatchesOnDesktop: lister_colour_swatches_visible_desktop, showSwatchesOnMobile: lister_colour_swatches_visible_mobile, singleActiveSizeFilterKeyName: singleActiveSizeFilterKeyName, showSizesOnHover: !isShopLanding, addDataMonetateProductId: true, enablePriceReference: lowest_price_all }, `${item.productCode}${item.colourId}${index}`));
                }), shownContentBlocks.map(generateRowBanner)] }));
};
